import {
  Injectable,
} from '@angular/core';
import {
  JourneyModel,
  JourneysStore,
  requestJourneyAcceptanceFromApi,
  selectSelectedJourney,
} from '@des/store/journeys';
import {
  Actions,
  createEffect,
  ofType,
} from '@ngrx/effects';
import {
  select,
  Store,
} from '@ngrx/store';
import {
  UiMessagePushMessages,
} from '@refx/shared-store';
import {
  AllianceCheckinService,
} from '@refx/ssci-services';
import {
  from,
  Observable,
} from 'rxjs';
import {
  filter,
  map,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';

/**
 * Effect to handle async Journeys actions
 */
@Injectable()
export class RefxJourneyAcceptanceEffect {
  /**
   * The selected journey
   */
  private readonly selectedJourney$: Observable<JourneyModel>;

  /**
   * Push confirmation message if journey is accepted
   *
   * TODO: Perhaps use the routing service to ensure that the seatmap comment
   *       being pushed here is only shown when routing to the seatmap page
   */
  public pushConfirmationMessageJourneyAcceptance$: Observable<any> = createEffect(() => (
    this.actions$.pipe(
      ofType(requestJourneyAcceptanceFromApi),
      switchMap((action) =>
        from(action.call).pipe(
          withLatestFrom(this.selectedJourney$),
          filter(([acceptanceReply, journeyReply]) => acceptanceReply.data.isAccepted
            && !this.allianceCheckinService.isAllianceCheckinFlow(journeyReply)),
          map(() => UiMessagePushMessages({
            payload: [{
              type: 'confirmation',
              titleKey: {
                key: 'global.check-in-validate'
              }
            }]
          }))
        )
      )
    )
  ));

  constructor(protected actions$: Actions, private readonly store: Store<JourneysStore>, private readonly allianceCheckinService: AllianceCheckinService) {
    this.selectedJourney$ = this.store.pipe(
      select(selectSelectedJourney),
      filter((journey: JourneyModel) => !!journey)
    );
  }
}
